import { z } from 'zod';

export const AppointmentTypeSchema = z
    .object({
        clinic_group_crm: z.string(),
        user_fk: z.string(),
        location_id: z.string(),
        service_type_id: z.string(),
        appointment_type_id: z.string(),
        display_name: z.nullable(z.string()),
        pms_name: z.nullable(z.string()),
        standard_duration: z.nullable(z.string()),
        is_face_to_face: z.nullable(z.string()),
        start_time: z.nullable(z.string()),
        end_time: z.nullable(z.string()),
        nurse_required: z.nullable(z.string()),
        is_default: z.nullable(z.string()),
        cancellation_period: z.nullable(z.string()),
        question_required: z.nullable(z.string()),
        continue_or_no: z.nullable(z.string()),
        appt_que: z.nullable(z.string()),
        appt_inst: z.nullable(z.string()),
        new_patient: z.nullable(z.string()),
        week_days_only: z.nullable(z.string()),
        week_end_only: z.nullable(z.string()),
        pre_payment_req: z.nullable(z.string()),
        pre_payment_fees: z.nullable(z.string()),
        pre_payment_msg: z.nullable(z.string()),
        pre_payment_cnfrm_msg: z.nullable(z.string()),
        post_payment_req: z.nullable(z.string()),
        post_billing_type: z.nullable(z.string()),
        post_billing_fees: z.nullable(z.string()),
        post_billing_msg: z.nullable(z.string()),
        post_billing_cnfrm_msg: z.nullable(z.string()),
        consent_enabled: z.nullable(z.string()),
        consent_id: z.nullable(z.string()),
        low_age_min: z.nullable(z.string()),
        low_age_max: z.nullable(z.string()),
        upper_age_min: z.nullable(z.string()),
        upper_age_max: z.nullable(z.string()),
        last_f2f_visit_months: z.nullable(z.string()),
        reason_for_visit: z.nullable(z.string()),
    })
    .partial()

export type AppointmentType = z.TypeOf<typeof AppointmentTypeSchema>;
